// src/containers/pages/caseManagement/components/CaseDetailsCard.tsx

import React from 'react';
import { Box, Paper, Typography } from 'components/mui';
import type { CANtrackCase } from '../types';

interface CaseDetailsCardProps {
  caseData: CANtrackCase | null;
  label: string; // "Source" or "Destination"
}

function CaseDetailsCard({ caseData, label }: CaseDetailsCardProps) {
  if (!caseData) {
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 140,
        }}
      >
        <Typography color="text.secondary" variant="body2">
          Select a case to view {label.toLowerCase()} details
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          Case ID: <strong>{caseData.id}</strong>
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {caseData.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Group: {caseData.gpd.group.title || '--'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Project: {caseData.gpd.project.title || '--'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Deliverable: {caseData.gpd.deliverable.title || '--'}
        </Typography>
      </Box>
    </Paper>
  );
}

export default CaseDetailsCard;
